var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-logos"},[_vm._l((_vm.themedPaymentLogos),function(ref,index){
var name = ref.name;
var imageUrl = ref.imageUrl;
var width = ref.width;
var height = ref.height;
return [_c('div',{key:index,staticClass:"img",attrs:{"title":_vm.$t(name)}},[_c('img',{attrs:{"width":width,"height":height,"src":imageUrl,"alt":name}})])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }